import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import DashBoardWhatsUp from './DashBoardWhatUp';
import DashBoardToday from './DashBoardToday';
import { getPartnerDashboard } from '@/api/dashboard/getPartnerDashboard';
import { useLoading } from '@/context/LoadingContext';
import { GetPartnerDashboardResponse } from '@/api/type/types';
import { Images } from '@/assets';

const DashBoard = () => {
  const [data, setData] = useState<GetPartnerDashboardResponse>({
    myPlayers: 0,
    receivedOrders: 0,
    receivedStars: 0,
    todaySection: {
      pending: 0,
      inProgress: 0,
      completed: 0,
    },
  });
  const { startLoading, stopLoading } = useLoading();

  const fetchDashboard = useCallback(async () => {
    startLoading();
    try {
      const res = await getPartnerDashboard();
      if (res.isSuccess) {
        setData(res.data);
      }
    } finally {
      stopLoading();
    }
  }, [startLoading, stopLoading]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return (
    <Container>
      <DashBoardWhatsUp data={data} />
      <DashBoardToday data={data} />
      <PointImg2 src={Images.MainPointImg2} alt="main-point-2" />
    </Container>
  );
};

export default DashBoard;

const Container = styled.div`
  display: flex;
  gap: 44px;
  position: relative;
`;

const PointImg2 = styled.img`
  position: absolute;
  right: 0;
  top: -51px;
  width: 80px;
  height: 92px;
`;
